import { useSelector, useDispatch } from 'react-redux'
import { useCallback } from 'react'

import { User } from '../../graphql/generated/graphql'
import { actions, selectors } from '../../redux'

export const useUser = (): { user: User | null; reset: () => void } => {
  const dispatch = useDispatch()
  const user = useSelector(selectors.auth.user)

  const reset = useCallback(() => {
    dispatch(actions.auth.loadUser())
  }, [dispatch])

  return {
    user,
    reset,
  }
}
